
import AOS from 'aos';
const Anim = () => {
    AOS.init({
        duration: 1500,
        easing: 'ease-in-out',
        once: true
    });
};
export default Anim;
